module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy@3x.bda158bf.png";